import React from 'react';
import { withStyles, Typography, Button } from '@material-ui/core';

// import styles from '../config/styles';

import videoFile from "../assets/FTlabsHomePage.mp4";
import posterFile from '../assets/poster2.png';

const styles = (theme) => ({
    videoRootContainer: {
        width: "100%",
        // 40em
        height: "40em",
        position: "relative",
        overflow: "hidden"
    },
    videoContainer: {
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    videoMessageContainer: {
        width: "100%",
        height: "100%",
        position: "absolute",
        display: "flex",
        background: "rgba(0,0,0,0.4)",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        top: 0,
        left: 0,
        color: "#fff",
    },
    companyTitle: {
        color: "#fff",
        fontFamily: 'Grand Hotel',
        fontSize: "80px",
        letterSpacing: ".02em",
        ['@media screen and (max-width: 420px)']: { // eslint-disable-line no-useless-computed-key
            fontSize: "60px"
        },
        ['@media screen and (max-width: 300px)']: { // eslint-disable-line no-useless-computed-key
            fontSize: "40px"
        },
    },
    companyMoto: {
        color: "#fff",
        fontFamily: 'Roboto',
        letterSpacing: ".1em",
        marginBottom: "5vw"
    }
})

class Hero extends React.Component {
    render() {
        const { classes } = this.props;
        return (
            <section >
                <div className={classes.videoRootContainer}>
                    <div className={classes.videoContainer}>

                        {/* <iframe src="https://www.youtube.com/embed/lujEOtIeN4c?controls=0&showinfo=0&rel=0&autoplay=1&mute=1&modestbranding=1&wmode=transparent" width="100%" height="100%" frameborder="0" allowfullscreen></iframe> */}

                        {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/lujEOtIeN4c" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe> */}

                        <video autoPlay loop>
                            <poster src={posterFile} />.
                            <source src={videoFile} type="video/mp4" />
                            Your Browser doesn't support video backgrounds, please upgrade to get the full experience
                        </video>
                        <div className={classes.videoMessageContainer}>
                            <Typography variant="display4" className={classes.companyTitle}>Futuristic Labs</Typography>
                            <Typography variant="subheading" className={classes.companyMoto}>
                                DREAM. BUILD. REPEAT.
                            </Typography>
                            <Button variant="contained" size="large" color="default" large="true" href="#openPositions">Join Us</Button>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default withStyles(styles)(Hero);